import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";

import { popupcontext } from "../../../context/Popupscontext";
import {
	useGetGroupsQuery,
	useGetUserGroupQuery,
} from "../../../Redux/service/Groups/Groups";

export default function GroupsMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);

	const [isOpen, setIsOpen] = useState(false);
	const [selectedGroups, setSelectedGroups] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AllGroups, refetch: AllGroupsRefetch } = useGetGroupsQuery(
		undefined,
		{ refetchOnMountOrArgChange: true }
	);

	let { data: UsersGroups, refetch: UsersGroupsReftech } = useGetUserGroupQuery(
		userId,
		{
			skip: !userId,
			refetchOnMountOrArgChange: true,
		}
	);

	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};

	const isFirstMount = useRef(true);
	useEffect(() => {
		if (AllGroups && UsersGroups) {
			const merged = [...AllGroups, ...UsersGroups];
			const unique = merged.filter(
				(item, index, self) => index === self.findIndex((t) => t.id === item.id)
			);
			setMergedData(unique);
		}
	}, [AllGroups, UsersGroups]);
	useEffect(() => {
		if (isFirstMount.current || AllGroupsRefetch || UsersGroupsReftech) {
			setGroups(
				mergedData?.map((i) => ({
					value: i.id,
					label: i.name,
				}))
			);
		}
		isFirstMount.current = false;
	}, [mergedData, AllGroupsRefetch, UsersGroupsReftech]);

	useEffect(() => {
		if (type === "users") {
			if (UsersGroups) {
				setSelectedGroups(UsersGroups?.map((i) => i.id));
			}
		}
	}, [UsersGroups, type]);

	useEffect(() => {
		if (isLinking) {
			if (type === "users") {
				UsersGroupsReftech();
			}
		}
	}, [isLinking, type, UsersGroupsReftech]);
	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedGroups((prev) => [...prev, value]);
						handleLink(value, "group", "Group");
					}}
					onDeselect={(value) => {
						setSelectedGroups((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "group", "Group");
					}}
					value={mergedData?.length > 0 ? selectedGroups : undefined}
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
